<template>
	<div>
		<!-- <div class="row">
			<div class="col-md-3">
				<button class="btn w-100" :class="{'btn-outline-secondary' : area != 'Jawa Timur' , 'btn-secondary' : area == 'Jawa Timur'}" type="button" @click="area = 'Jawa Timur'">Jawa Timur</button>
			</div>
			<div class="col-md-3">
				<button class="btn w-100" :class="{'btn-outline-secondary' : area != 'NTT' , 'btn-secondary' : area == 'NTT'}" type="button" @click="area = 'NTT'">NTT</button>
			</div>
		</div> -->

		<div class="mt-1">
			<div style="background-color:white">
				<NewMap :area="area" :data="data" v-if="geojson && data" :geojson="geojson" :mapType="mapType" :type="type" @showTotal="showTotal" @changeDoc="changeDoc"
				@toggleServiceDate="toggleServiceDate" :toggleService="toggleService" :dataMarket="dataMarket" :dataMarketDocs="dataMarketDocs" :dataMarketDealer="dataMarketDealer"
				ref="newmap" :trendSales="trendSales" />
				<fold v-else :loading="true"></fold>
			</div>
		</div>
	</div>
</template>

<script>
import Map from './Map'
import NewMap from './NewMap'
import { FoldSpinner } from 'vue-spinners'

export default {
	components: {
		Map,
		NewMap,
		fold : FoldSpinner
	},
	mounted () {
		console.log(this.data)
	},
	props: ['area','data' , 'mapType', 'type' , 'toggleService', 'dataMarket' , 'dataMarketDocs', 'dataMarketDealer' , 'trendSales'],
	data () {
		return {
			geojson : null
		}
	},
	async created() {
		const response = await fetch(`https://storage.googleapis.com/mpm-geojson-id/Jawa%20Timur.json`)
        let data = await response.json();
        const response2 = await fetch(`https://storage.googleapis.com/mpm-geojson-id/NTT.json`)
        let data2 = await response2.json();

		// const response = await fetch(`/Jawa%20Timur.json`)
        // let data = await response.json();
        // const response2 = await fetch(`/NTT.json`)
        // let data2 = await response2.json();

		// console.log(data.features.find(x => x.id == "ID5371031"))
		// console.log(data2.features.find(x => x.id == "ID5371031"))

        data.features =  data.features.concat(data2.features)
        this.geojson = data

	},
	methods : {
		download () {
			this.$refs.newmap.exportExcel()
		},
		showTotal (data) {
			this.$emit('showTotal' , data)
		},
		changeDoc (data) {
			console.log(data)
			this.$emit('changeDoc' , data)
		},
		toggleServiceDate (data) {
			this.$emit('toggleServiceDate' , data)
		}
	}
}
</script>